import { render, staticRenderFns } from "./ListMarineInsurance.vue?vue&type=template&id=ed586a06&scoped=true&"
import script from "./ListMarineInsurance.vue?vue&type=script&lang=js&"
export * from "./ListMarineInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed586a06",
  null
  
)

export default component.exports